module.exports = __webpack_public_path__ + "static/media/item_36_7.96876829.jpg";